import React from "react";
import { useReveal } from "../hooks/useReveal";

// Wrapper that fades + slides its children in on scroll
const Reveal = ({ children, delay = 0, className = "", as: Tag = "div" }) => {
  const [ref, inView] = useReveal();
  const delayClass = delay ? ` reveal-delay-${delay}` : "";
  return (
    <Tag ref={ref} className={`reveal${inView ? " in-view" : ""}${delayClass} ${className}`}>
      {children}
    </Tag>
  );
};

export default Reveal;
